<div class="p-4 sm:p-6 space-y-4 sm:space-y-6">
  <!-- Header -->
  <div class="flex items-center justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">
        Avtomatik xabar matnlari
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        Telegram orqali mijozlarga yuboriladigan xabarlar. Matnni o'zgartirsangiz keyingi
        yuborishdan boshlab kuchga kiradi.
      </p>
    </div>
    <button
      (click)="load()"
      [disabled]="loading()"
      class="p-2 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors shrink-0"
    >
      <lucide-icon
        [img]="RefreshCw"
        class="w-4 h-4 text-gray-500"
        [class.animate-spin]="loading()"
      ></lucide-icon>
    </button>
  </div>

  @if (loading() && templates().length === 0) {
    <div class="flex justify-center py-16">
      <div
        class="w-8 h-8 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"
      ></div>
    </div>
  } @else {
    <div class="space-y-6">
      @for (group of groups(); track group.key) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
        >
          <!-- Xabar sarlavhasi -->
          <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-800">
            <h2 class="font-semibold text-gray-900 dark:text-gray-100">{{ group.description }}</h2>
            <div class="flex flex-wrap items-center gap-1.5 mt-2">
              <span class="text-xs text-gray-500 dark:text-gray-400">Ishlatsa bo'ladi:</span>
              @for (token of group.tokens; track token) {
                <code
                  class="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-xs font-mono text-gray-700 dark:text-gray-300"
                  >{{ token }}</code
                >
              }
            </div>
          </div>

          <!-- Har til uchun matn -->
          <div class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (row of group.rows; track row.language) {
              <div class="px-5 py-4 space-y-2">
                <div class="flex items-center justify-between gap-2 flex-wrap">
                  <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
                      languageLabel(row.language)
                    }}</span>
                    @if (isCustom(row)) {
                      <span
                        class="px-2 py-0.5 rounded-full bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 text-xs font-medium"
                        >o'zgartirilgan</span
                      >
                    } @else {
                      <span class="text-xs text-gray-400">standart matn</span>
                    }
                  </div>

                  <div class="flex flex-wrap items-center gap-1.5">
                    @for (token of group.tokens; track token) {
                      <button
                        type="button"
                        (click)="insertToken(row, token)"
                        class="px-1.5 py-0.5 rounded border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 text-xs font-mono text-gray-600 dark:text-gray-400"
                        title="Matn oxiriga qo'shish"
                      >
                        {{ token }}
                      </button>
                    }
                  </div>
                </div>

                <label class="sr-only" [attr.for]="'body-' + row.key + '-' + row.language"
                  >Matn</label
                >
                <textarea
                  [id]="'body-' + row.key + '-' + row.language"
                  [ngModel]="draft(row)"
                  (ngModelChange)="onDraftChange(row, $event)"
                  rows="4"
                  class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono leading-relaxed"
                ></textarea>

                <div class="flex items-center justify-between gap-2 flex-wrap">
                  <p class="text-xs text-gray-400">
                    HTML ruxsat etiladi:
                    <code class="font-mono">&lt;b&gt;qalin&lt;/b&gt;</code>
                  </p>

                  <div class="flex items-center gap-2">
                    @if (isCustom(row)) {
                      <button
                        (click)="resetToDefault(row)"
                        [disabled]="savingKey() === slot(row)"
                        class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 text-xs disabled:opacity-40"
                      >
                        <lucide-icon [img]="RotateCcw" class="w-3.5 h-3.5"></lucide-icon>
                        Standartga qaytarish
                      </button>
                    }
                    <button
                      (click)="save(row)"
                      [disabled]="!isDirty(row) || savingKey() === slot(row)"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white text-xs font-medium"
                    >
                      <lucide-icon [img]="Save" class="w-3.5 h-3.5"></lucide-icon>
                      Saqlash
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div
      class="flex items-start gap-2 rounded-xl bg-blue-50 dark:bg-blue-900/20 px-4 py-3 text-sm text-blue-800 dark:text-blue-300"
    >
      <lucide-icon [img]="Info" class="w-4 h-4 mt-0.5 shrink-0"></lucide-icon>
      <span>
        Matn bo'sh qoldirilsa yoki "Standartga qaytarish" bosilsa, tizimdagi asl matn ishlatiladi —
        xabar hech qachon yuborilmay qolmaydi.
      </span>
    </div>
  }
</div>
